import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { getSMTPFunc, addSMTPFunc} from '../action/emailSettingAction';
import SMTPComponent from '../components/smptComponent';

export class SMTPContainer extends Component{
    constructor(props){
        super(props)
    }
    componentDidMount(){
        this.props.actions.getSMTPFunc();
    }
    getSMTPdata = () =>{
        this.props.actions.getSMTPFunc(
            this.props.dispatch
        )
    }
    
    addSMTPdetails = (payload) =>{
        this.props.actions.addSMTPFunc(
            payload,
            this.props.dispatch
        )
    }
    render(){
        return(
            // <EmailSettingComponent
            //     getAllEmailSettingData = {this.props.emailSettingData}
            //     updateRejection = {this.applicationRejection}
            //     updateApproval = {this.approvalTime}
            //     updateForgotPswd = {this.forgotPassword}
            //     updateRegistration = {this.registrationTime}
            //     allEmailSetting = {this.allEmailSetting}
            // >    
            // </EmailSettingComponent>
            <SMTPComponent
            addSMTPdetails = {this.addSMTPdetails}
            getAllEmailSettingData = {this.props.emailSettingData}
            getSMTPdata = {this.getSMTPdata}
            >
            </SMTPComponent>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch: dispatch,
        actions: bindActionCreators({
            getSMTPFunc,
            addSMTPFunc
        },
            dispatch)
    };
}
function mapStateToProps({ EmailSettingReducer }) {
    console.log(EmailSettingReducer);
    return {
        emailSettingData : {
            errorCode : EmailSettingReducer.errorCode,
            statusCode : EmailSettingReducer.statusCode,
            // emailSettingList : EmailSettingReducer.emailSettingList,
            // updatedEmailSetting : EmailSettingReducer.updatedEmailSetting,
            Message : EmailSettingReducer.Message,
            // SubjectList : [],
            isLoading : EmailSettingReducer.isLoading,
            SMTPdetail : EmailSettingReducer.SMTPdetail
        }
    }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SMTPContainer));
